import React from 'react';

import NotificationModal from '../components/notificationModal';

function Invoices() {
  return (<NotificationModal />);
}

export default Invoices;
